import { useMemo, useState } from "react";

export const FINANCE_UNITS_TABLE_MAX_HEIGHT = 680;

function compareValues(a, b, direction) {
  const multiplier = direction === "asc" ? 1 : -1;
  if (a == null && b == null) return 0;
  if (a == null || a === "") return multiplier;
  if (b == null || b === "") return -multiplier;

  const aNum = Number(a);
  const bNum = Number(b);
  if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
    return (aNum - bNum) * multiplier;
  }

  return (
    String(a).localeCompare(String(b), undefined, {
      numeric: true,
      sensitivity: "base",
    }) * multiplier
  );
}

export function unitSortKey(row) {
  return row.unit_code || row.unit_name || String(row.unit_id || "");
}

export function useClientTableSort(rows, accessors, defaultField = "unit_code") {
  const [sortField, setSortField] = useState(defaultField);
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection((direction) => (direction === "asc" ? "desc" : "asc"));
      return;
    }
    setSortField(field);
    setSortDirection("asc");
  };

  const sortedRows = useMemo(() => {
    const accessor = accessors[sortField];
    if (!accessor) return rows;

    return [...rows].sort((left, right) =>
      compareValues(accessor(left), accessor(right), sortDirection)
    );
  }, [rows, accessors, sortField, sortDirection]);

  return { sortedRows, sortField, sortDirection, handleSort };
}
